import { render } from "./CV.vue?vue&type=template&id=21e144ae&scoped=true"
import script from "./CV.vue?vue&type=script&lang=js"
export * from "./CV.vue?vue&type=script&lang=js"

import "./CV.vue?vue&type=style&index=0&id=21e144ae&scoped=true&lang=scss"

import exportComponent from "/Users/ecm1922/Code/jakob-schloer.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e144ae"]])

export default __exports__